'use client';

import {useAdfoxStore} from '@shared/Ads/Yandex/store';

import {ScriptLoader} from './ScriptLoader';
import {StatsSink} from './StatsSink';

export const AdFoxController = ({statsUrl}: {statsUrl: string}) => {
  const isContextAds = useAdfoxStore().adFoxState.adFoxHasAds;
  if (!isContextAds) {
    return null;
  }
  return (
    <>
      <ScriptLoader />
      <StatsSink statsUrl={statsUrl} />
    </>
  );
};
